import { Component, Input, OnInit } from '@angular/core';
import { faEnvelope, faGlobe, faPhone } from '@fortawesome/free-solid-svg-icons';
import { Club } from 'app/shared/models/Club/clubs';

@Component({
  selector: 'app-list-clubs',
  templateUrl: './list-clubs.component.html',
  styleUrls: ['./list-clubs.component.scss']
})
export class ListClubsComponent implements OnInit {

  @Input() club: Club;
  @Input() index: number;

  faGlobe = faGlobe;
  faPhone = faPhone;
  faEnvelope = faEnvelope;
  lat: number;
  long: number;
  dist: string;


  constructor(
  ) { }

  ngOnInit(): void {
    this.dist = this.club.distance?.toFixed(2);
  }


}
